import { TPaginationParams } from '@/types/meta';

export type TCalculationLog = {
  id: number;
  date: string;
  text: string;
};

export enum UploadingDataStatusTypes {
  WEEKLY_DATA_UPLOADING = 1,
  GAS_RECALCULATION = 2,
  DBF_UPLOADING = 3,
  NSI_UPLOADING = 4,
  ADDITIONAL_UPLOADING = 5,
  ADDITIONAL_GAS_UPLOADING = 6,
}

export type TUploadingDataStatus = {
  isProgress: boolean;
  type: UploadingDataStatusTypes | null;
};

export type TCalculationActiveInfo = {
  isProgress?: boolean;
  type?: UploadingDataStatusTypes;
  processingId?: string;
  startedAt?: string;
  createdAt?: string;
};

export type TCalculationInfoParams = TPaginationParams<{
  isActive?: boolean;
  loaderType?: UploadingDataStatusTypes;
}>;
